import { DEFAULT_SORT_PROFILE, type SortProfile } from '../types/sort-profile.types';

export function resolveSortProfile(
  profiles: SortProfile[],
  customerId: string | null,
): SortProfile {
  if (customerId) {
    const customerProfile = profiles.find(
      (p) => !p.isDefault && p.customerIds.includes(customerId),
    );
    if (customerProfile) return customerProfile;
  }
  return profiles.find((p) => p.isDefault) ?? DEFAULT_SORT_PROFILE;
}
